import { models } from '@kurtosys/ksys-app-template';
import { BaseStore } from './BaseStore';
import { EventPublish } from 'src/models/eventManager';
import { EventGlobalInputsChangeDetail } from 'src/models/eventManager/detail';

export class InputsStore extends BaseStore {
    public async updateInputs(values: Record<string, any>) {
        this.cleanValues(values);
        this.stores.data.updateGlobalInputs(values);
    }

    public handleUpdate = async (
        event: EventPublish<EventGlobalInputsChangeDetail>
    ) => {
        const identifier = this.stores.eventBusStore.getSourceAppIdFromEvent(
            event
        );
        // TODO: customEvent.detail does not have the filterValues defined,
        // will need to update the interface in app template
        const { storageType, values } = event.detail;
        // sync values passed from the event
        if (values) {
            this.updateInputs({ ...(values || {}) });
        }
        // sync values from storage
        else {
            const storageValues = this.getFromStorage(identifier, storageType);
            if (storageValues) {
                await this.updateInputs(storageValues);
            }
        }
    };

    public getStorageId(rawIdentifier: string) {
        return `${rawIdentifier}-${this.currentUrlKey}`;
    }

    /**
     * Get the global input out of storage, and apply fallback searches
     *
     * @param identifier
     * @param [storageType=eventBus.StorageType.Session]
     * @returns
     */
    private getFromStorage(
        identifier: string,
        storageType: models.eventBus.StorageType = models.eventBus.StorageType
            .Session
    ): Record<string, any> | undefined {
        let storage;
        switch (storageType) {
            case models.eventBus.StorageType.Local:
                storage = localStorage;
                break;
            case models.eventBus.StorageType.Session:
                storage = sessionStorage;
                break;
            default:
                return;
        }
        const storageValues = this.getStorageValue(storage, identifier);

        // As we do not know how the global input app is setup to store its values when initializing the current app, we have to look at the default session storage, and fallback to local storage.
        if (
            !storageValues &&
            storageType === models.eventBus.StorageType.Session
        ) {
            return this.getFromStorage(
                identifier,
                models.eventBus.StorageType.Local
            );
        }
        return storageValues;
    }

    /**
     * Pull global input value out of the target storage type, and convert it into an object.
     *
     * @param storage
     * @param rawIdentifier
     * @returns
     */
    private getStorageValue(
        storage: Storage,
        rawIdentifier: string
    ): Record<string, any> | undefined {
        let storageValue = storage.getItem(this.getStorageId(rawIdentifier));
        if (!storageValue) {
            // fallback to legacy storage key where the URL was not considered
            storageValue = storage.getItem(rawIdentifier);
        }
        if (storageValue) {
            try {
                // jsonTryParse?
                return JSON.parse(storageValue);
            } catch (e) {
                console.warn('Input Store > Get Storage Value Error', e);
            }
        }
        return;
    }

    /**
     * The global inputs app has the option to store an object with a label and value to help identify which item to pre-select
     * This method parses the object and only returns the value to assist with input placeholders e.g. {input:date}
     *
     * @private
     * @param [values]
     */
    private cleanValues(values: Record<string, any>) {
        for (const key of Object.keys(values)) {
            if (
                values[key] &&
                typeof values[key] === 'object' &&
                values[key].label &&
                values[key].value
            ) {
                values[key] = values[key].value;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/stores/InputsStore.ts